import React from "react";
import { injectIntl } from "react-intl";
import styled from "styled-components";
import ServiceUpdatePlayingPokoro from "@/common/Images/ServiceUpdatePlayingPokoro.png";
import {useHistory} from "react-router-dom";

/**
 * [기존 회원] 서비스 업데이트 안내 모달
 * Figma: 포코로 팝업 (node 1314:3837)
 * 스펙: 닫기(X) 없음, 배경(백드롭) 탭으로 닫히지 않음 — 버튼 동작은 상위에서 연결.
 */
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  box-sizing: border-box;
  z-index: 10000;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 328px;
  padding: 32px 24px;
  background-color: #ffffff;
  border-radius: 20px;
  box-sizing: border-box;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
  color: #333333;
  text-align: center;
`;

const Illustration = styled.img`
  width: 44px;
  height: 44px;
  object-fit: contain;
  flex-shrink: 0;
`;

const Body = styled.div`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: #333333;
  text-align: center;
  white-space: normal;
  width: 100%;
`;

const PrimaryButton = styled.button`
  width: 100%;
  min-height: 52px;
  padding: 16px;
  margin: 0;
  border: 2px solid #fdd751;
  border-radius: 8px;
  background-color: #fdd751;
  color: #333333;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  cursor: pointer;
  box-sizing: border-box;
  font-family: inherit;

  &:active {
    opacity: 0.92;
  }
`;

function ServiceUpdatePopup({ open, intl }) {
  const history = useHistory();
  if (!open) return null;

  const handleClick = () => {
    history.push("/signin/nickname", { notNewUser: true });
  };

  return (
    <Overlay role="presentation" aria-hidden={!open}>
      <Card
        role="dialog"
        aria-modal="true"
        aria-labelledby="service-update-modal-title"
      >
        <Title id="service-update-modal-title">
          {intl.formatMessage({ id: "ServiceUpdatePopup_title" })}
        </Title>
        <Illustration
          src={ServiceUpdatePlayingPokoro}
          alt={intl.formatMessage({ id: "ServiceUpdatePopup_illustration_alt" })}
        />
        <Body>
            {intl.formatMessage({ id: "ServiceUpdatePopup_body" })}
        </Body>
        <PrimaryButton type="button" onClick={handleClick}>
          {intl.formatMessage({ id: "ServiceUpdatePopup_button" })}
        </PrimaryButton>
      </Card>
    </Overlay>
  );
}

export default injectIntl(ServiceUpdatePopup);
